<script setup lang="ts">
const { t } = useI18n();

useSeoMeta({
  title: t('seo.home.title'),
  titleTemplate: "",
});

const faqs = computed(() => [
  {
    question: t('faq.items.0.question'),
    answer: t('faq.items.0.answer'),
  },
  {
    question: t('faq.items.1.question'),
    answer: t('faq.items.1.answer'),
  },
  {
    question: t('faq.items.2.question'),
    answer: t('faq.items.2.answer'),
  },
  {
    question: t('faq.items.3.question'),
    answer: t('faq.items.3.answer'),
  },
  {
    question: t('faq.items.4.question'),
    answer: t('faq.items.4.answer'),
  },
  {
    question: t('faq.items.5.question'),
    answer: t('faq.items.5.answer'),
  },
  {
    question: t('faq.items.6.question'),
    answer: t('faq.items.6.answer'),
  },
]);
</script>

<template>
  <main>
    <LandingHero />
    <LandingFeatures :lazy-loading="false" />

    <LandingBento />

    <LandingSignature />

    <LandingPricing />

    <Faq :faqs="faqs" />

    <!-- <LandingTestimonials />  -->

    <LandingEndCta />
  </main>
</template>
